var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Carousel'),_c('Bienvenido'),_c('Encontraras'),_c('Informacion'),_c('Enfermedad'),_c('Producto'),_c('Consulta'),_c('Revisa'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }